 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML00_COVER from '@/components/html/00_Cover'
 import HTML03_COPYRIGHT from '@/components/html/03_Copyright'
 import HTML02_TITLE_PAGE from '@/components/html/02_Title_Page'
 import HTML04_CONTENTS from '@/components/html/04_CONTENTS'
 import HTML05_PROLOGUE from '@/components/html/05_PROLOGUE'
 import HTML06_INTRODUCTION__MY_BRAIN_IN_A_DISH from '@/components/html/06_INTRODUCTION__My_Brain_in_a_Dish'
 import HTML07_CHAPTER_1__PIECES_OF_LIFE__CELLS from '@/components/html/07_CHAPTER_1__Pieces_of_Life__Cells'
 import HTML08_CHAPTER_2__BODY_BUILDING__GROWIN from '@/components/html/08_CHAPTER_2__Body_Building__Growin'
 import HTML09_FIRST_INTERLUDE__THE_HUMAN_SUPER from '@/components/html/09_FIRST_INTERLUDE__The_Human_Super'
 import HTML10_CHAPTER_3__IMMORTAL_FLESH__HOW_T from '@/components/html/10_CHAPTER_3__Immortal_Flesh__How_t'
 import HTML11_SECOND_INTERLUDE__HEROES_AND_VIL from '@/components/html/11_SECOND_INTERLUDE__Heroes_and_Vil'
 import HTML12_CHAPTER_4__TWISTS_OF_FATE__HOW_T from '@/components/html/12_CHAPTER_4__Twists_of_Fate__How_t'
 import HTML13_CHAPTER_5__THE_SPARE_PARTS_FACTO from '@/components/html/13_CHAPTER_5__The_Spare_Parts_Facto'
 import HTML14_CHAPTER_6__FLESH_OF_MY_FLESH__QU from '@/components/html/14_CHAPTER_6__Flesh_of_My_Flesh__Qu'
 import HTML15_CHAPTER_7__HIDEOUS_PROGENY___THE from '@/components/html/15_CHAPTER_7__Hideous_Progeny___The'
 import HTML16_THIRD_INTERLUDE__PHILOSOPHY_OF_T from '@/components/html/16_THIRD_INTERLUDE__Philosophy_of_t'
 import HTML17_CHAPTER_8__RETURN_OF_THE_MEATWAR from '@/components/html/17_CHAPTER_8__Return_of_the_Meatwar'
 import HTML18_ACKNOWLEDGEMENTS from '@/components/html/18_ACKNOWLEDGEMENTS'
 import HTML19_ENDNOTES from '@/components/html/19_ENDNOTES'
 import HTML20_BIBLIOGRAPHY from '@/components/html/20_BIBLIOGRAPHY'
 import HTML21_PICTURE_CREDITS from '@/components/html/21_PICTURE_CREDITS'
 import HTML22_INDEX from '@/components/html/22_INDEX'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/04_CONTENTS",
 			"name" : "html/04_CONTENTS",
 			"component" : HTML04_CONTENTS
 		},
 		{
 			"path" : "/html/05_PROLOGUE",
 			"name" : "html/05_PROLOGUE",
 			"component" : HTML05_PROLOGUE
 		},
 		{
 			"path" : "/html/06_INTRODUCTION__My_Brain_in_a_Dish",
 			"name" : "html/06_INTRODUCTION__My_Brain_in_a_Dish",
 			"component" : HTML06_INTRODUCTION__MY_BRAIN_IN_A_DISH
 		},
 		{
 			"path" : "/html/07_CHAPTER_1__Pieces_of_Life__Cells",
 			"name" : "html/07_CHAPTER_1__Pieces_of_Life__Cells",
 			"component" : HTML07_CHAPTER_1__PIECES_OF_LIFE__CELLS
 		},
 		{
 			"path" : "/html/08_CHAPTER_2__Body_Building__Growin",
 			"name" : "html/08_CHAPTER_2__Body_Building__Growin",
 			"component" : HTML08_CHAPTER_2__BODY_BUILDING__GROWIN
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js